/**
 * Fetcher function to be used with SWR
 * @param args - Arguments to be passed to fetch
 * @returns - JSON response
 */
export const baseFetcher = (
  ...args: [input: RequestInfo | URL, init?: RequestInit]
) => fetch(...args).then((res) => res.json())
